/* Copyright © 2026 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, including without limitation, material generated from the software programs which are displayed on the screen such as icons, screen display looks, etc. */

import { Component } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AccessListService } from '../../services/access-list.service';
import { User, UserService } from '../../services/user.service';
import { XdaStringsService } from '../../services/xda-strings.service';
import { AccessListItem } from '../accessList/invite-user.component';
import { BasicAlertComponent } from '../alerts/basic-alert.component';
import { ChangePasswordComponent } from './change-password.component';

@Component({
  selector: 'my-account',
  templateUrl: './my-account.component.html',
  standalone: false,
})
export class MyAccountComponent {
  user: User | null;

  constructor(
    public activeModal: NgbActiveModal,
    private userService: UserService,
    private xdaStringsService: XdaStringsService,
    private modalService: NgbModal,
    private accessListService: AccessListService,
  ) {
    this.user = userService.user;
  }

  async editAccount() {
    const agBaseUrl = this.xdaStringsService.strings['AGBASEURL'];
    let redirectUrl = "";
    if (this.userService.useAuthCodes) {
      const baseUrl = `${agBaseUrl}#!/edit-account`;
      redirectUrl = await this.userService.createAuthCodeRedirect(baseUrl);
    } else {
      await this.userService.refreshToken(this.userService.getRefreshToken());
      const appId = encodeURIComponent(this.xdaStringsService.strings['APPID']);
      const refreshToken = encodeURIComponent(this.userService.getRefreshToken());
      redirectUrl = `${agBaseUrl}#!/edit-account?appId=${appId}&refreshToken=${refreshToken}`;
    }
    window.location.href = redirectUrl;
  }

  changePassword() {
    this.modalService.open(ChangePasswordComponent, {
      windowClass: 'xrx-modal',
    });
  }

  confirmRemove() {
    const modalRef = this.modalService.open(BasicAlertComponent);
    modalRef.componentInstance.title = 'SDE_CONFIRM_REMOVE_ACCOUNT1';
    modalRef.componentInstance.buttonText = 'SDE_CANCEL';
    modalRef.componentInstance.dangerButtonText = 'SDE_REMOVE';
    modalRef.result.then((data) => {
      if (data === 'Delete') {
        this.removeFromSubscription();
      }
    });
  }

  async removeFromSubscription() {
    try {
      const accessListItem: AccessListItem = {
        accessListId: this.user?.accessListId || '',
        userId: this.user?.id || '',
        appId: this.xdaStringsService.strings['APPID'],
        managerId: this.user?.id || '',
        accessListRole: 'User',
      };
      await this.accessListService.removeFromAccessList(accessListItem);
      this.logout();
    } catch (error) {
      console.log(error);
    }
  }

  logout() {
    this.userService.logOff();
  }
}
